__turbopack_context__.v({
  "card": "EngagingPopup-module__yfa9cG__card",
  "cardLink": "EngagingPopup-module__yfa9cG__cardLink",
  "closeIcon": "EngagingPopup-module__yfa9cG__closeIcon",
  "confetti": "EngagingPopup-module__yfa9cG__confetti",
  "content": "EngagingPopup-module__yfa9cG__content",
  "contentMain": "EngagingPopup-module__yfa9cG__contentMain",
  "description": "EngagingPopup-module__yfa9cG__description",
  "fallbackIcon": "EngagingPopup-module__yfa9cG__fallbackIcon",
  "mediaWrap": "EngagingPopup-module__yfa9cG__mediaWrap",
  "meta": "EngagingPopup-module__yfa9cG__meta",
  "root": "EngagingPopup-module__yfa9cG__root",
  "thumbnail": "EngagingPopup-module__yfa9cG__thumbnail",
  "thumbnailFallback": "EngagingPopup-module__yfa9cG__thumbnailFallback",
  "title": "EngagingPopup-module__yfa9cG__title",
  "visible": "EngagingPopup-module__yfa9cG__visible",
});
